import { transparentize } from 'polished';
import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components/src/FocusButton';
import { responsive, sp, timing } from '@main/theme';

/**
 * The Wrapper props
 */
export interface WrapperProps {
  /** Whether the action is disabled or not */
  disabled?: boolean;
  /** For SS wizard, whether the action is selected or not */
  selected?: boolean;
}

/**
 * The Button top banner wrapper
 */
export const TopWrapper = styled.div`
  display: flex;
  margin-bottom: ${sp(2)};
  justify-content: space-between;
`;

/**
 * The Icon wrapper
 */
export const IconWrapper = styled.img`
  width: ${sp(6.5)};
`;

/**
 * The Header Wrapper
 */
export const HeaderWrapper = styled.h3`
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  font-size: ${sp(2.15)};

  ${responsive.beforeTablet} {
    margin-bottom: ${sp(0.5)};
  }
`;

/**
 * The Description Wrapper
 */
export const DescriptionWrapper = styled.p`
  color: ${({ theme }) => theme.colors.black};
  text-align: left;
  font-size: ${sp(1.9)};
  margin-bottom: ${sp(0.35)};
`;

/**
 * The Text Wrapper
 */
export const TextWrapper = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  padding-left: ${sp(0.5)};
`;

/**
 * The step count wrapper
 */
export const StepWrapper = styled.p<WrapperProps>`
  color: ${({ theme }) => theme.colors.transcendNavy2};
  font-size: ${sp(1.9)};

  ${responsive.atLeastDesktop} {
    opacity: ${({ disabled }) => (disabled ? 1 : 0)};
    transition: ${timing.short} opacity;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

/**
 * The FocusButton wrapper
 */
export const FocusButtonWrapper = styled(FocusButton)`
  width: 100%;
  height: 100%;
  border-radius: ${sp(1)};

  &:hover,
  &:focus {
    .action-step {
      opacity: 1;
    }
  }
`;

/**
 * The ActionButton wrapper
 */
export const ActionButtonWrapper = styled.section<WrapperProps>`
  height: 100%;
  width: 100%;
  background-color: ${({ selected, theme }) =>
    selected
      ? transparentize(0.97, theme.colors.transcend)
      : theme.colors.white};
  border-radius: ${sp(1)};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${sp(2)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border: ${({ selected, theme }) =>
    selected
      ? `1px solid ${theme.colors.transcend}`
      : `1px solid ${transparentize(0.2, theme.colors.transcendNavy4)}`};
  transition: all 0.2s;
  box-shadow: 0 1px ${sp(1)}
    ${({ theme }) => transparentize(0.8, theme.colors.transcendNavy4)};

  ${responsive.atLeastTablet} {
    padding: ${sp(2.5)} ${sp(3)};
  }

  ${responsive.atLeastDesktop} {
    padding: ${sp(2.5)} ${sp(3)} ${sp(3)} ${sp(3)};
  }
`;
